<template>
  <nav
    ref="nav"
    class="topic-jumpletters-wrapper"
    :aria-labelledby="`topic-jumpletters-${uuid}`"
    :style="{ top: `${stickyTopPosition}px` }"
  >
    <span :id="`topic-jumpletters-${uuid}`" class="a-visually-hidden">
      <a-label path="jumpletters.nav.label"></a-label>
    </span>
    <bpb-scroller
      id="topic-scroller"
      :flickity-config="{
        freeScroll: true,
        contain: true,
        customAccessibility: true,
      }"
      class="topic-jumpletters"
    >
      <slot></slot>
    </bpb-scroller>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex';
import { attempt } from '@js/utils/various';

export default {
  data() {
    return {
      uuid: this.$uuid.v1(),
      stickyTopPosition: 0,
    };
  },
  computed: {
    ...mapGetters({
      breakpointUp: 'window/breakpointUp',
    }),
    hasDesktopHeader() {
      return this.breakpointUp('lg');
    },
  },
  watch: {
    hasDesktopHeader(data) {
      this.setStickyTopPosition(data);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.setStickyTopPosition(true);
    });
  },
  methods: {
    getComputedCss(el, prop) {
      return window.getComputedStyle(el, null).getPropertyValue(prop);
    },
    /**
     * Returns the `.nav-menu` Element
     * @returns {HTMLElement}
     */
    getNavMenuElement() {
      return document.querySelector('.nav-menu');
    },

    /**
     * Attempts to get the `.nav-menu` Element, 5 times with an delay of 10ms
     * These both numbers could be tweaked if problems occur..
     * @returns {HTMLElement}
     */
    attemptGetNavMenuElement(callback) {
      return attempt(() => this.getNavMenuElement(), {
        max: 5,
        delay: 10,
      })
        .then(result => callback(result.result))
        .catch(({ attempts }) => {
          throw Error('.nav-menu element was not found, via bpb-header');
        });
    },

    calcStickyTopPosition(navMenu) {
      const paddingTop = this.getComputedCss(
        this.$refs.nav,
        'padding-top'
      ).replace(/\D/g, '');
      const paddingBottom = this.getComputedCss(
        this.$refs.nav,
        'padding-bottom'
      ).replace(/\D/g, '');

      return navMenu.clientHeight - paddingTop - paddingBottom;
    },

    setStickyTopPosition(setTrue) {
      if (setTrue) {
        this.attemptGetNavMenuElement(this.calcStickyTopPosition).then(
          result => {
            this.stickyTopPosition = result;
          }
        );
        return;
      }

      this.stickyTopPosition = 0;
    },
  },
};
</script>
